<template>
	<div>
		<div class="tw-mt-5">
			<AppButton
				:label="$t('integrations.whatsapp-qr-start-session-button')"
				size="xl"
				class="tw-rounded-full"
				:loading="true"
			/>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { Marketplace } from '../../../../entities/marketplace';
import { Alert } from '@/v2/plugins/alert';

const linkMarketplaceStore = useLinkMarketplaceStore();

const onStartSession = async () => {
	try {
		await Marketplace.startWhatsAppQRSession({
			session_name: linkMarketplaceStore.whatsappQrSession?.name,
			linked_marketplace_id: linkMarketplaceStore.linkedMarketplaceId,
		});

		nextStep();
	} catch (err) {
		Alert.error(err?.response?.data?.message);
	}
};

const nextStep = async () => {
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} catch (err) {
		Alert.error(err?.response?.data?.message);
	}
};

onMounted(() => {
	onStartSession();
});
</script>
